<div *ngIf="fieldType !== 'root'" [formGroup]="$any(field)" class="property-row" [ngClass]="{'collection-row': isArrayOrObject}">
  <div class="property-expand">
    <fw-icon *ngIf="isArrayOrObject" (click)="expanded = !expanded" class="expand-collapse" size="small" color="slate">{{expanded ? "chevron-up" : "chevron-down"}}</fw-icon>
  </div>
  <div class="property-key">
    <ng-container *ngIf="writable && !isArrayMember">
      <input type="text" [attr.data-id]="fieldType + '-key-field'"
        formControlName="key" matInput placeholder="Key">
      <ng-container *ngIf="field.invalid && field.touched">
        <mat-error *ngIf="field.get('key').hasError('required')">{{ 'infoEditProperty.errors.requiredKey' | translate }}</mat-error>
        <mat-error *ngIf="field.get('key').hasError('duplicateKey')">{{ 'infoEditProperty.errors.duplicateKey' | translate }}</mat-error>
        <mat-error *ngIf="field.get('key').hasError('invalidCharacter')">{{ 'infoEditProperty.errors.invalidCharacter' | translate }}</mat-error>
      </ng-container>
    </ng-container>
    <span *ngIf="!writable && !isArrayMember">{{ field.get('key').value }}</span>
    <span *ngIf="isArrayMember">[{{ index }}]</span>
  </div>
  <div class="property-value">
    <ng-container *ngIf="!isArrayOrObject">
      <input *ngIf="writable && fieldType !== 'boolean'" [type]="fieldType === 'number' ? 'number' : 'text'"
        [attr.data-id]="fieldType + '-value-field'"
        formControlName="value"
        matInput placeholder="Value">
      <mat-checkbox *ngIf="writable && fieldType === 'boolean'"
        [attr.data-id]="'boolean-value-field'" formControlName="value"></mat-checkbox>
      <span *ngIf="!writable">{{ field.get('value').value }}</span>
    </ng-container>
    <ng-container *ngIf="isArrayOrObject">
      <button *ngIf="!expanded && hasInvalidMember" mat-icon-button
        (click)="revealInvalidDescendants()"
        [matTooltip]="'infoEditProperty.errors.invalidDescendant' | translate"
        class="invalid-member xs">
        <mat-icon>error</mat-icon>
      </button>
      <em *ngIf="field.value.length === 0">This {{ fieldType }} is empty.</em>
    </ng-container>
  </div>
  <div class="property-actions">
    <span *ngIf="writable && isArrayOrObject">
      <button class="small" [matMenuTriggerFor]="addMenu" class="collection-button btn btn-default btn-sm blue">
        <fw-icon color="slate" class="info-trash-icon">add-new-create</fw-icon>
      </button>
      <mat-menu #addMenu="matMenu">
        <button mat-menu-item (click)="addMember('string')"><mat-icon class="info-icon">text_fields</mat-icon> {{ 'infoEdit.fieldTypes.string' | translate }}</button>
        <button mat-menu-item (click)="addMember('boolean')"><mat-icon class="info-icon">toggle_on</mat-icon> {{ 'infoEdit.fieldTypes.boolean' | translate }}</button>
        <button mat-menu-item (click)="addMember('number')"><mat-icon class="info-icon">123</mat-icon> {{ 'infoEdit.fieldTypes.number' | translate }}</button>
        <button mat-menu-item (click)="addMember('array')"><mat-icon class="info-icon">list</mat-icon> {{ 'infoEdit.fieldTypes.array' | translate }}</button>
        <button mat-menu-item (click)="addMember('object')"><mat-icon class="info-icon">data_object</mat-icon> {{ 'infoEdit.fieldTypes.object' | translate }}</button>
      </mat-menu>
    </span>
    <mat-icon class="field-type">{{ typeIconClass }}</mat-icon>
    <button *ngIf="writable" [attr.data-id]="'delete-' + fieldType + '-button'"
      (click)="delete.emit(field.value)" class="btn btn-default btn-action">
      <fw-icon color="slate" class="info-trash-icon">trash-delete</fw-icon>
    </button>
  </div>
</div>
<div *ngIf="isArrayOrObject && expanded || fieldType === 'root'" [ngClass]="{ 'property-children': fieldType !== 'root' }">
  <info-property *ngFor="let member of formArray.controls; trackBy:memberTrackBy; index as $index"
    [field]="member"
    [index]="$index"
    [parent]="field"
    [writable]="writable"
    (delete)="deleteMember($index)">
  </info-property>
</div>
